import { KatSpinner } from "@amzn/katal-react";
import React, { type FC, type ReactNode, useCallback, useState } from "react";
import type { InboundComplianceGroupDetails } from "src/api/interfaces/inbound_compliance_group";
import { RetrievalState } from "src/constants";

const DEFAULT_CONTEXT: InboundComplianceGroupDetails = {
  inboundComplianceGroupDetails: [],
  inMemoryInboundComplianceGroupDetails: [],
  setInboundComplianceGroupDetails: () => {},
};

export const InboundComplianceGroupDetailsContext =
  React.createContext<InboundComplianceGroupDetails>(DEFAULT_CONTEXT);

export const useInboundComplianceGroupDetails = () =>
  React.useContext(InboundComplianceGroupDetailsContext);

export const InboundComplianceGroupDetailsContextProvider: FC<{
  children?: ReactNode;
}> = ({ children }) => {
  const [inboundComplianceGroupDetails, setInboundComplianceGroupDetails] =
    useState<InboundComplianceGroupDetails>(DEFAULT_CONTEXT);

  const getInboundComplianceGroupDetailsContextValue = useCallback(
    () => ({
      ...inboundComplianceGroupDetails,
      setInboundComplianceGroupDetails,
    }),
    [inboundComplianceGroupDetails, setInboundComplianceGroupDetails]
  );

  return (
    <InboundComplianceGroupDetailsContext.Provider
      value={getInboundComplianceGroupDetailsContextValue()}
    >
      {inboundComplianceGroupDetails.groupDetailsRetrievalState ===
        RetrievalState.LOADING && <KatSpinner size="small" />}
      {children}
    </InboundComplianceGroupDetailsContext.Provider>
  );
};
